<template>
<div class="form-group mt-4 mb-3" v-show="shouldShow()">
    <div class="col-md-12 p-0">
        <label :for="item.label">
            <Lock v-if="item.response_private" />
            {{item.label | multitranslate}}
            <span v-if="item.required">*</span>
        </label>
        <p v-if="item.instructions">
            {{item.instructions | multitranslate}}
        </p>
    
        <div v-if="hasTime">
            <datetime input-class="form-control" v-model="content" type="datetime"></datetime>
        </div>
        <div v-else>
            <datetime input-class="form-control" v-model="content"></datetime>
        </div>
    </div>
</div>
</template>

<style scoped>
  .form-control {
    border-radius: 10px !important;
  }

  .form-group p {
    display: block;
    width: 100%;
  }

  label {
    font-weight: bold;
    text-transform: uppercase;
    font-family: Montserrat, sans-serif, BlinkMacSystemFont, Segoe UI, Roboto, Helvetica Neue, Arial, Apple Color Emoji, Segoe UI Emoji, Segoe UI Symbol, Noto Color Emoji;
    color :#373e46;
    margin-bottom: 0 !important;
  }

  label span {
    color: red;
  }
</style>

<script>
import AbstractForm from './AbstractForm.vue';
export default {
    extends: AbstractForm,
    name: 'DateTimeField',
    props: {
        item: {
            type: Object,
            required: true
        },
        hasTime: {
            type: Boolean,
            required: false,
            default:false
        }
    },
    data: function() {
        return {
            
        }
    },
    created() {

    },
    methods: {

    }
}
</script>
